import React, { useMemo } from 'react'
import { Tag, Link } from '@overdose/components'
import classNames from 'classnames'
import { Image } from '~/components/Image'
import { getImageSrc } from '~/helpers'
import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './MakerHubArticleCard.module.css'
import { MakerHubArticleCardProps } from './MakerHubArticleCard.types'

const MakerHubArticleCard = ({
  className,
  title,
  excert,
  image,
  url,
  urlText,
  categories,
}: MakerHubArticleCardProps) => {
  const availableCategories = useMemo(() => {
    return categories?.filter((category) => {
      return category.name
    })
  }, [categories])
  return (
    <article
      className={`${classNames(
        styles.root,
        styles.wrapper,
        styles['card-wrapper'],
        className
      )} pb-6`}>
      {url && (
        <Link
          className={styles.link}
          to={url}
          title={`${title} details`}
          ariaLabel={`${title} details`}
        />
      )}
      {image && (
        <div className={styles['image-wrapper']}>
          <Image
            title={title}
            src={getImageSrc(image.src, '500')}
            addSrcSet={false}
            sources={
              <source
                srcSet={getImageSrc(image.src, '750')}
                media='(max-width: 768px)'
              />
            }
            alt={image.altText}
            width={image.width}
            height={image.height}
            className='object-cover w-full h-full rounded-md'
          />
        </div>
      )}
      <div
        className={classNames(
          styles.textArea,
          'flex flex-col grow p-4 justify-between'
        )}>
        {availableCategories?.length > 0 && (
          <div
            className='flex gap-2 flex-wrap pb-2'
            style={
              {
                '--tag-default-color-bg': 'var(--color-typography-heading)',
                '--tag-default-color-text': 'white',
              } as React.CSSProperties
            }>
            {availableCategories.map((category) => {
              return (
                <Tag key={category.uid} size='sm' variant='default'>
                  <Typography
                    className='uppercase'
                    tag={TypographyTag.span}
                    variant={TypographyVariant.BodySmallBold}>
                    {category.name}
                  </Typography>
                </Tag>
              )
            })}
          </div>
        )}
        <div className={classNames('flex flex-col')}>
          <Typography
            tag={TypographyTag.p}
            variant={TypographyVariant.BodyLargeBold}
            className={classNames(
              styles.title,
              'line-clamp-2 lg:line-clamp-2 mb-4 !text-[var(--color-typography-heading)]'
            )}>
            {title}
          </Typography>
          <Typography
            tag={TypographyTag.p}
            variant={TypographyVariant.BodyRegular}
            className={classNames(
              styles.excert,
              'line-clamp-2 text-greyscale-900 lg:line-clamp-2 mb-8'
            )}>
            {excert}
          </Typography>
          {url && (
            <Link
              to={url}
              variant='secondary'
              className={classNames('underline text-greyscale-900')}
              title={`${title} details`}>
              <Typography
                tag={TypographyTag.p}
                variant={TypographyVariant.BodyRegular}>
                {urlText || 'Read more'}
              </Typography>
            </Link>
          )}
        </div>
      </div>
    </article>
  )
}

export default MakerHubArticleCard
